export const themes = {
  whatsapp: {
    name: "WhatsApp",
    mainBg:
      "bg-[radial-gradient(1200px_500px_at_5%_-10%,#d1fae5_0%,transparent_55%),radial-gradient(1000px_450px_at_100%_0%,#dbeafe_0%,transparent_50%),linear-gradient(180deg,#f8fafc_0%,#ecfeff_55%,#f8fafc_100%)]",
    headerBg: "bg-white/80",
    grpBG: "bg-emerald-600",
    headerBorder: "border-emerald-200/60",
    logoBG: "bg-emerald-50",
    titleColor: "text-emerald-700",
    headerText: "text-slate-800",
    sidebarBg: "bg-white/80 backdrop-blur-xl",
    sidebarText: "text-slate-700",
    sidebarHover: "hover:bg-emerald-50",
    sidebarActive: "bg-emerald-100",
    sidebarBorder: "border-emerald-200/60",
    accentColor: "bg-emerald-600",
    buttonHover: "hover:bg-emerald-700",
    iconColor: "text-emerald-600",
    sideBarsIcon: "text-emerald-700",
    iconHover: "group-hover:text-emerald-700",
    contentBg: "bg-white/80 backdrop-blur-lg",
    contentBorder: "border-emerald-200/70",
    footerBg: "bg-gradient-to-r from-emerald-700 via-teal-700 to-cyan-700",
    inputFocusRing: "focus:ring-emerald-400/55",
    primary: "emerald-500",
  },

  minimal: {
    name: "Minimal",
    mainBg:
      "bg-[radial-gradient(1200px_480px_at_5%_-10%,#c7d2fe_0%,transparent_55%),radial-gradient(1100px_450px_at_100%_0%,#e9d5ff_0%,transparent_50%),linear-gradient(180deg,#f8f7ff_0%,#eef2ff_52%,#f5f3ff_100%)]",
    logoBG: "bg-indigo-50",
    headerBg: "bg-white/80",
    grpBG: "bg-violet-600",
    headerBorder: "border-indigo-200/70",
    headerText: "text-slate-800",
    sidebarBg: "bg-white/80 backdrop-blur-xl",
    sidebarText: "text-slate-700",
    sidebarHover: "hover:bg-indigo-50/90",
    sidebarActive: "bg-indigo-100/90",
    sidebarBorder: "border-indigo-200/70",
    accentColor: "bg-indigo-600",
    buttonHover: "hover:bg-indigo-700",
    iconColor: "text-indigo-600",
    sideBarsIcon: "text-indigo-700",
    titleColor: "text-indigo-700",
    iconHover: "group-hover:text-violet-700",
    contentBg: "bg-white/80 backdrop-blur-lg",
    contentBorder: "border-indigo-200/70",
    footerBg: "bg-gradient-to-r from-indigo-700 via-violet-700 to-indigo-800",
    inputFocusRing: "focus:ring-indigo-400/55",
    primary: "indigo-500",
  },
};
// dark: {
//   name: "Dark",
//   mainBg: "bg-gray-900",
//   headerBg: "bg-gray-800",
//   headerBorder: "border-gray-700/30",
//   headerText: "text-white",
//   logoBG: "bg-gray-200",
//   sidebarBg: "bg-gray-800",
//   sidebarText: "text-gray-200",
//   sidebarHover: "hover:bg-gray-700",
//   sidebarActive: "bg-gray-600",
//   sidebarBorder: "border-gray-700/30",
//   accentColor: "bg-primary-500",
//   iconColor: "text-primary-400",
//   iconHover: "group-hover:text-primary-300",
//   contentBg: "bg-gray-800",
//   contentBorder: "border-gray-700/30",
//   footerBg: "bg-gray-800",
// },
//   whiteYellow: {
//     name: "White & Yellow",
//     mainBg: "bg-gradient-to-br from-yellow-50 via-white to-yellow-50",
//     headerBg: "bg-gradient-to-r from-yellow-500 to-yellow-600",
//     headerBorder: "border-yellow-400/30",
//     sidebarBg: "bg-gradient-to-b from-white via-yellow-50 to-yellow-100",
//     sidebarText: "text-gray-800",
//     sidebarHover: "hover:bg-yellow-100/50",
//     sidebarActive: "bg-yellow-200/80",
//     sidebarBorder: "border-yellow-200/30",
//     accentColor: "bg-yellow-400",
//     iconColor: "text-yellow-600",
//     iconHover: "group-hover:text-yellow-700",
//     contentBg: "bg-white/90",
//     contentBorder: "border-yellow-100/50",
//     footerBg: "bg-gradient-to-r from-yellow-500 to-yellow-600",
//   },
// blueOcean: {
//   name: "Blue Ocean",
//   mainBg: "bg-gradient-to-br from-primary-100 to-teal-100",
//   headerBg: "bg-gradient-to-r from-primary-600 to-teal-600",
//   headerBorder: "border-primary-500/30",
//   sidebarBg: "bg-gradient-to-b from-primary-700 to-teal-700",
//   sidebarText: "text-white",
//   sidebarHover: "hover:bg-primary-600/50",
//   sidebarActive: "bg-primary-600/80",
//   sidebarBorder: "border-primary-500/30",
//   accentColor: "bg-teal-400",
//   iconColor: "text-teal-300",
//   iconHover: "group-hover:text-white",
//   contentBg: "bg-white/90",
//   contentBorder: "border-primary-100/30",
//   footerBg: "bg-gradient-to-r from-primary-600 to-teal-600",
// },
// sunset: {
//   name: "Sunset",
//   mainBg: "bg-gradient-to-br from-orange-100 to-pink-100",
//   headerBg: "bg-gradient-to-r from-orange-500 to-pink-500",
//   headerBorder: "border-orange-400/30",
//   sidebarBg: "bg-gradient-to-b from-orange-600 to-pink-600",
//   sidebarText: "text-white",
//   sidebarHover: "hover:bg-orange-500/50",
//   sidebarActive: "bg-orange-500/80",
//   sidebarBorder: "border-orange-400/30",
//   accentColor: "bg-pink-400",
//   iconColor: "text-pink-300",
//   iconHover: "group-hover:text-white",
//   contentBg: "bg-white/90",
//   contentBorder: "border-orange-100/30",
//   footerBg: "bg-gradient-to-r from-orange-500 to-pink-500",
// },
// forest: {
//   name: "Forest",
//   mainBg: "bg-gradient-to-br from-green-100 to-emerald-100",
//   headerBg: "bg-gradient-to-r from-green-600 to-emerald-600",
//   headerBorder: "border-green-500/30",
//   sidebarBg: "bg-gradient-to-b from-green-700 to-emerald-700",
//   sidebarText: "text-white",
//   sidebarHover: "hover:bg-green-600/50",
//   sidebarActive: "bg-green-600/80",
//   sidebarBorder: "border-green-500/30",
//   accentColor: "bg-emerald-400",
//   iconColor: "text-emerald-300",
//   iconHover: "group-hover:text-white",
//   contentBg: "bg-white/90",
//   contentBorder: "border-green-100/30",
//   footerBg: "bg-gradient-to-r from-green-600 to-emerald-600",
// },
// purpleDream: {
//   name: "Purple Dream",
//   mainBg: "bg-gradient-to-br from-purple-100 to-violet-100",
//   headerBg: "bg-gradient-to-r from-purple-600 to-violet-600",
//   headerBorder: "border-purple-500/30",
//   sidebarBg: "bg-gradient-to-b from-purple-700 to-violet-700",
//   sidebarText: "text-white",
//   sidebarHover: "hover:bg-purple-600/50",
//   sidebarActive: "bg-purple-600/80",
//   sidebarBorder: "border-purple-500/30",
//   accentColor: "bg-violet-400",
//   iconColor: "text-violet-300",
//   iconHover: "group-hover:text-white",
//   contentBg: "bg-white/90",
//   contentBorder: "border-purple-100/30",
//   footerBg: "bg-gradient-to-r from-purple-600 to-violet-600",
// },
// candy: {
//   name: "Candy",
//   mainBg: "bg-gradient-to-br from-pink-100 to-red-100",
//   headerBg: "bg-gradient-to-r from-pink-500 to-red-500",
//   headerBorder: "border-pink-400/30",
//   sidebarBg: "bg-gradient-to-b from-pink-600 to-red-600",
//   sidebarText: "text-white",
//   sidebarHover: "hover:bg-pink-500/50",
//   sidebarActive: "bg-pink-500/80",
//   sidebarBorder: "border-pink-400/30",
//   accentColor: "bg-red-400",
//   iconColor: "text-red-300",
//   iconHover: "group-hover:text-white",
//   contentBg: "bg-white/90",
//   contentBorder: "border-pink-100/30",
//   footerBg: "bg-gradient-to-r from-pink-500 to-red-500",
// },
// nightSky: {
//   name: "Night Sky",
//   mainBg: "bg-gradient-to-br from-gray-800 to-primary-900",
//   headerBg: "bg-gradient-to-r from-gray-900 to-primary-900",
//   headerBorder: "border-primary-800/30",
//   sidebarBg: "bg-gradient-to-b from-gray-900 to-primary-900",
//   sidebarText: "text-gray-200",
//   sidebarHover: "hover:bg-primary-800/50",
//   sidebarActive: "bg-primary-800/80",
//   sidebarBorder: "border-primary-800/30",
//   accentColor: "bg-primary-500",
//   iconColor: "text-primary-400",
//   iconHover: "group-hover:text-primary-300",
//   contentBg: "bg-gray-800/90",
//   contentBorder: "border-primary-800/30",
//   footerBg: "bg-gradient-to-r from-gray-900 to-primary-900",
// },
// earth: {
//   name: "Earth",
//   mainBg: "bg-gradient-to-br from-amber-100 to-green-100",
//   headerBg: "bg-gradient-to-r from-amber-600 to-green-600",
//   headerBorder: "border-amber-500/30",
//   sidebarBg: "bg-gradient-to-b from-amber-700 to-green-700",
//   sidebarText: "text-white",
//   sidebarHover: "hover:bg-amber-600/50",
//   sidebarActive: "bg-amber-600/80",
//   sidebarBorder: "border-amber-500/30",
//   accentColor: "bg-green-400",
//   iconColor: "text-green-300",
//   iconHover: "group-hover:text-white",
//   contentBg: "bg-white/90",
//   contentBorder: "border-amber-100/30",
//   footerBg: "bg-gradient-to-r from-amber-600 to-green-600",
// },
// original: {
//   name: "Original",
//   mainBg: "bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50",
//   headerBg: "bg-gradient-to-r from-indigo-600 to-purple-600",
//   headerBorder: "border-indigo-500/30",
//   sidebarBg: "bg-gradient-to-b from-indigo-900 via-purple-900 to-pink-900",
//   sidebarText: "text-white",
//   sidebarHover: "hover:bg-indigo-600/50",
//   sidebarActive: "bg-indigo-600/80",
//   sidebarBorder: "border-indigo-500/30",
//   accentColor: "bg-purple-400",
//   iconColor: "text-purple-300",
//   iconHover: "group-hover:text-white",
//   contentBg: "bg-white/80",
//   contentBorder: "border-none",
//   footerBg: "bg-gradient-to-r from-indigo-600 to-purple-600",
// },
